import { Component, OnDestroy, OnInit } from '@angular/core';
import { NotificacionesService } from 'src/app/shared/services/notificacion/notificacion.service';
import { ErrorService } from 'src/app/shared/services/error/error.service';
import { SocketConnectionService } from 'src/app/shared/services/socketConnection/socket-connection.service'; 
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../../services/auth/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificacionesModalComponent } from '../../../../../components/notificaciones-modal/notificaciones-modal.component';
import { ComprobantesViewComponent } from 'src/app/components/comprobantes/components/comprobantes-view/comprobantes-view.component';
import { OrdenesEntregaViewComponent } from 'src/app/components/ordenes_entrega/ordenes-entrega-view/ordenes-entrega-view.component';
import { Subscription } from 'rxjs';
import { CANAL_SOCKET, TIPO_RECEPTOR_CLIENTE } from 'src/app/shared/utils/constantes/constantes-notificaciones';

declare var require
const Swal = require('sweetalert2');
const confToast = {
  timeOut: 10000
}

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit, OnDestroy {

  public openNotification: boolean = false;
  public NotifNoLeidas: number = 0;
  public Notificaciones: any;

  private subscriptions: Subscription[] = [];
  public modalOpen: boolean = false;

  constructor(private notificacionesService: NotificacionesService,
    private errorService: ErrorService,
    private socketConn: SocketConnectionService,
    private toast: ToastrService,
    private authService: AuthService,
    private modalService:NgbModal,) { }

  ngOnInit() {
    // this.InicializarNotifPush();
    if (this.authService.usuario.admin === undefined) {
      this.loadNotif(this.cargarFiltros());
      // MC CATFER-117 Se refresca el listado al recibir una notificacion websocket
      this.subscriptions.push(
        this.notificacionesService.refreshListado.subscribe((refresh) => {
          if (refresh && !this.modalOpen) {
            this.loadNotif(this.cargarFiltros());
          }
        })
      );
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }

  cargarFiltros(){
    // MC CATFER-117 Se cambian los parámetros para adaptarlo al nuevo esquema
    let datos: any = {
      IdsReceptoresConTipos: `[${this.authService.usuario.id_cliente}|${TIPO_RECEPTOR_CLIENTE}]`,
      Estados: 'N',
      IdsNotifCanales: CANAL_SOCKET,
      PageNumber: 1,
      PageSize: 5,
      Orden: 7,
      SentidoOrden: 'desc',
    };
    return datos;
  }

  toggleNotificationMobile() {
    this.openNotification = !this.openNotification;
  }

  loadNotif(datos: object){
    const susc = this.notificacionesService.getNotificaciones(datos).subscribe((data) => {
      this.Notificaciones = data.Data; 
      this.NotifNoLeidas = data.TotalRecords;
    },
    (error: any) => {
      this.errorService.getError(error.status);
    });
    this.subscriptions.push(susc);   
  }

  mostrarToast(mensaje: string){
    this.toast.success(mensaje, '', confToast);
  }


  ObservacionToJSON(observacion: string): any {
    return JSON.parse(observacion);
  }

  onNotificaciones(){
    this.modalOpen = true;
    const modalRef = this.modalService.open(NotificacionesModalComponent, { size: 'lg' });
    modalRef.result.then((resolve) => {
      this.modalOpen = false;
      this.loadNotif(this.cargarFiltros());  
    }).catch((error) => { this.modalOpen = false }); 
  }

  marcarLeidos(idNotif:number){
    // MC CATFER-117 Se cambia el valor para representar Leido a L en lugar de N
    let notifPatch : any = [
      {"op": "replace",
      "path": "/Estado",
      "value": "L" }
    ];
    const susc = this.notificacionesService.pathNotificaciones(idNotif,notifPatch).subscribe(
      (data) => { this.loadNotif(this.cargarFiltros());},
      (error: any) => {}
    );
    this.subscriptions.push(susc); 
  }

  LeerNotif(notif: any){
    // MC CATFER-117 Se accede directamente
    let dominio : string = notif.Observacion.dominio_registro;
    let tipoCba : string = '';    
    switch (dominio) {
      case 'OE':
        this.getOrdenEntrega(notif.IdRegistro);
        tipoCba = 'Ordenes';
        break;
    
      default:
        break;
    }
    this.marcarLeidos(notif.Id);
  }

  getComprobante(IdRegistro : number,tipoCba: string){
    const modalRef = this.modalService.open(ComprobantesViewComponent, { size: <any>'xl'  });
      modalRef.componentInstance.comprobanteId = IdRegistro;
      modalRef.componentInstance.tipoComprobante = tipoCba;
      modalRef.result.then((resolve) => { 
      }); 
  }  

  getOrdenEntrega(id: number){
    const modalRef = this.modalService.open(OrdenesEntregaViewComponent, { size: 'lg' });
    modalRef.componentInstance.ordenId = id;
    modalRef.result.then((resolve) => {
    }).catch((error) => {}); 
  }

}
